export default __webpack_public_path__ + "static/media/piano_3.2b1357bc.png";